import Component from '../core/Component'

export default class CheckboxValidation extends Component {

    prepare() {
        this.element.addEventListener('nette:valid', ::this.handleValid)
        this.element.addEventListener('nette:invalid', ::this.handleInvalid)
    }

    handleValid(event) {
        event.preventDefault()
        const element = event.target;

        const errorElement = this.element.querySelector('.InputError');
        if (errorElement) {
            this.element.removeChild(errorElement);
        }

        element.classList.remove('has-error');
        element.classList.add('is-valid');
    }

    handleInvalid(event) {
        event.preventDefault()
        const element = event.target;

        let errorElement = this.element.querySelector('.InputError');

        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.className = 'InputError';
        }

        errorElement.innerHTML = element.getAttribute('data-nette-error');
        this.element.appendChild(errorElement);
        element.classList.add('has-error');
        element.classList.remove('is-valid');
    }
}